import axios from '../Axios/Default';
import { handleResponse, getMultipartOptions } from './HelperService';

const getAssets = (params, onSuccess, onError) => {
    const response = axios.get(`/api/v1/admin/asset`, {params});
    return handleResponse(response, onSuccess, onError);
};

const getAssetById = (id, onSuccess, onError) => {
    const response = axios.get(`api/v1/admin/asset/${id}`);
    return handleResponse(response, onSuccess, onError);
};

const uploadAsset = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/asset`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const updateAsset = (id, payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/asset/${id}`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const softDeleteAsset = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setAccessUrl = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/access`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setCounter = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/counter`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setToPublic = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/setpublic`, payload);
    return handleResponse(response, onSuccess, onError);
};

const sharedUrl = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/asset/share`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setToArchive = (id, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/archived`);
    return handleResponse(response, onSuccess, onError);
};

const setStorageClass = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/stgclass`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setAclClass = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/objacl`, payload);
    return handleResponse(response, onSuccess, onError);
};

const setToRestore = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/asset/${id}/restore`, payload);
    return handleResponse(response, onSuccess, onError);
};


export { getAssets, getAssetById, uploadAsset, updateAsset, softDeleteAsset, setAccessUrl, setCounter, setToPublic, sharedUrl, setToArchive, setToRestore, setStorageClass, setAclClass };